import React from 'react';

const AUTHOR_CLASSNAMES = {
  wrapper: 'author',
  image: 'author-image',
  details: 'author-details',
  authorFullName: 'author-fullname',
  authorUserName: 'author-username'
};


function buildBemElements(bemBlock, modifier, element){
  const elementClassName = `${bemBlock}__${AUTHOR_CLASSNAMES[element]}`;
  return `${elementClassName} ${elementClassName}--${modifier}`;
}
export const FanvoiceAuthorDetails = ({ blockName, modifier, author: { image, fullname, username } }) => {
  const blockElementWithModifer = buildBemElements.part(blockName, modifier);
  return (
    <div className={ blockElementWithModifer('wrapper') }>
      <img className={ blockElementWithModifer('image') } src={ image } />
      <div className={ blockElementWithModifer('details') }>
        <div className={ blockElementWithModifer('authorFullName') }> { fullname }</div>
        <div className={ blockElementWithModifer('authorUserName') }> { username }</div>
      </div>
    </div>
  );
};


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fanvoice/components/fanvoiceAuthorDetails.js